import { useCallback } from 'react'
import { PREFER_CACHE } from '@constants/index'
import { useClaimRecord } from '@hooks/useClaimRecord'
import { CommerceInsuranceData } from '../types'

type UseInsuranceDataServiceResult = {
  getInsuranceData: () => Promise<CommerceInsuranceData>
}

/**
 * @returns simplified insurance data to commerce F/E
 */
export const useInsuranceDataService = (): UseInsuranceDataServiceResult => {
  const { fetchClaimRecord } = useClaimRecord()

  const getInsuranceData = useCallback(async (): Promise<CommerceInsuranceData> => {
    try {
      const claimRecord = await fetchClaimRecord(PREFER_CACHE)
      const claimData = claimRecord?.claimData

      return {
        insurerName: claimData?.primaryCoverage?.insurer?.name,
      }
    } catch (error) {
      return {}
    }
  }, [fetchClaimRecord])

  return {
    getInsuranceData,
  }
}
